export interface ContactItem {
  icon: string;
  label: string;
  value: string;
  sub: string;
  href: string | null;
}

export interface SocialLink {
  icon: string;
  href: string;
  label: string;
  color: string;
}

/**
 * Contact channel details for the Contact Page.
 */
export const contactInfo: ContactItem[] = [
  {
    icon: 'ri-map-pin-line',
    label: 'Visit Us',
    value: 'Mankhurd, Mumbai, India',
    sub: 'We welcome walk-ins Mon–Sat',
    href: null,
  },
  {
    icon: 'ri-phone-line',
    label: 'Call Us',
    value: '+91 9594073820',
    sub: 'Mon–Fri 9 AM–7 PM, Sat 10 AM–5 PM',
    href: 'tel:+919594073820',
  },
  {
    icon: 'ri-mail-line',
    label: 'Email Us',
    value: 'info@nfskills.com',
    sub: 'We reply within 24 hours',
    href: 'mailto:info@nfskills.com',
  },
  {
    icon: 'ri-whatsapp-line',
    label: 'WhatsApp',
    value: '+91 9594073820',
    sub: 'Quick replies on WhatsApp',
    href: 'https://api.whatsapp.com/send/?phone=9594073820',
  },
];

/**
 * Social media links for Footer and Contact Page.
 */
export const socialLinks: SocialLink[] = [
  { icon: 'ri-facebook-fill', href: 'https://www.facebook.com/NFSIKILLS/', label: 'Facebook', color: 'hover:bg-[#1877F2]' },
  { icon: 'ri-youtube-fill', href: 'https://www.youtube.com/@nfskillsd', label: 'YouTube', color: 'hover:bg-[#FF0000]' },
  { icon: 'ri-whatsapp-fill', href: 'https://api.whatsapp.com/send/?phone=9594073820', label: 'WhatsApp', color: 'hover:bg-[#25D366]' },
  { icon: 'ri-linkedin-fill', href: 'https://www.linkedin.com/in/nf-skills-72223533a/', label: 'LinkedIn', color: 'hover:bg-[#0A66C2]' },
  { icon: 'ri-instagram-fill', href: 'https://www.instagram.com/nfskills/', label: 'Instagram', color: 'hover:bg-[#E1306C]' },
];

/**
 * Official center timing.
 */
export const officeHours: [string, string][] = [
  ['Monday – Friday', '9:00 AM – 7:00 PM'],
  ['Saturday', '10:00 AM – 5:00 PM'],
  ['Sunday', 'Closed'],
];
